/**
 * @module Main.section
 *
 * The main section which required authentication before being accessed. This is
 * where the main nav and the header show up and contain many pages where many
 * interfaces are presented to the user to make actions.
 */
import MainSection from './Main.layout';

export default MainSection;
